import { observable } from "mobx";
import { isEmpty } from "../../../utils";
import BaseChannelSettings from "./BaseChannelSettings";

export default class RingCentralChannelSettings extends BaseChannelSettings {
    @observable sender: string = '';
    @observable clientId: string = '';
    @observable userJwt: string = '';

    constructor(settings?: Partial<RingCentralChannelSettings>) {
        super();
        if (settings) this.update(settings);
    }

    get isValid() {
        return !isEmpty(this.accessToken)
            && !isEmpty(this.sender)
            && !isEmpty(this.clientId)
            && !isEmpty(this.userJwt);
    }

    update(entity: Partial<RingCentralChannelSettings>, allowUndefined = false) {
        super.update(entity, allowUndefined);
    }

    hasChanges(settings: RingCentralChannelSettings) {
        return super.hasChanges(settings)
            || this.sender !== settings.sender
            || this.clientId !== settings.clientId
            || this.userJwt !== settings.userJwt;
    }

    clone() {
        return new RingCentralChannelSettings(this);
    }
}